import Vue from 'vue'
import Vuex from 'vuex'
import b64 from "../tools/b64"

Vue.use(Vuex)

let initAuth = {
  username: '',
  jwt: '',
  posicion: 'Usuario',
  pais: 'estados unidos',
  userType: 0,
  id: null
}

let auth = localStorage.getItem('auth')
auth = auth ? { ...initAuth, ...JSON.parse(auth) } : initAuth

let flag = localStorage.getItem('flag')
flag = flag ? flag : 'GLO'

let cart = localStorage.getItem('cart')
if (cart) {
  const JsonCart = JSON.parse(cart);
  if (JsonCart.owner == null || JsonCart.owner == auth.id) {
    cart = { ...JsonCart, owner: auth.id }
  } else {
    cart = {
      seller: {
        name: "",
        id: 0
      },
      items: [],
      owner: null
    }
  }
} else {
  cart = {
    seller: {
      name: "",
      id: 0
    },
    items: [],
    owner: null
  };

}

let changes = null;

export default new Vuex.Store({
  state: {
    auth: auth,
    flag: flag,
    changes: changes,
    counters: {
      products: 0,
      services: 0
    },
    cart: cart
  },
  mutations: {
    setFlag(state, flag) {
      state.flag = flag;
      localStorage.setItem('flag', flag)
    },
    addItemCart(state, item) {
      let _ = state.cart.items.findIndex(x => x.id == item.id)
      state.cart.owner = state.auth.id;
      if (_ > -1) {
        state.cart.items[_].amount = item.amount
      }

      localStorage.setItem('cart', JSON.stringify(state.cart))
    },
    removeItemCart(state, item) {
      let _ = state.cart.items.filter(x => x.id != item)

      state.cart.items = _

      state.cart.seller = _.length ? state.cart.seller : {
        name: "",
        id: 0
      }

      state.cart.owner = state.auth.id;

      localStorage.setItem('cart', JSON.stringify(state.cart))
    },
    clearItemCart(state) {
      localStorage.removeItem("cart")
      state.cart = {
        seller: {
          name: "",
          id: 0
        },
        items: [],
        owner: null
      }
    },
    setItemCart(state, item) {
      if (state.cart.seller.id != item.seller.id) {
        state.cart.items = [];
      }
      let _ = state.cart.items.findIndex(x => x.id == item.item.id)
      if (_ > -1) {
        state.cart.items[_].amount += item.item.amount
      } else {
        state.cart.items.push(item.item)
        state.cart.seller = item.seller
      }

      localStorage.setItem('cart', JSON.stringify(state.cart))
    },
    setAuth(state, auth) {
      localStorage.setItem('auth', JSON.stringify(auth))
      state.auth = auth;
      location.href = location.pathname == "/login" ? "/" : b64.decode(location.pathname.replace("/login/", ""))
    },
    setChanges(state, changes) {
      state.changes = changes;
    },
    setCounters(state, counters) {
      state.counters = counters;
    },
    deleteAuth(state) {
      localStorage.removeItem('auth')
      state.auth = {
        username: '',
        jwt: '',
        _id: '',
        posicion: 'Usuario',
        pais: 'estados unidos',
        userType: 0
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
